import { render, staticRenderFns } from "./BookingCheckoutComponent.vue?vue&type=template&id=b2d49352&scoped=true"
import script from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"
export * from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"
import style0 from "./BookingCheckoutComponent.vue?vue&type=style&index=0&id=b2d49352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d49352",
  null
  
)

export default component.exports